import { render, staticRenderFns } from "./TabMuestreos.vue?vue&type=template&id=00694ffc&scoped=true&"
import script from "./TabMuestreos.vue?vue&type=script&lang=js&"
export * from "./TabMuestreos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00694ffc",
  null
  
)

export default component.exports